module.exports = __webpack_public_path__ + "media/point-4.af928c77.mp3";